import { PartialTranslation } from '../translations';

export const de: PartialTranslation = {
  newChat: 'Neuer Chat',
  search: 'Suchen',
  user: 'Benutzer',
  settings: 'Einstellungen',
  language: 'Sprache',
  getHelp: 'Hilfe erhalten',
  viewAllPlans: 'Alle Pläne anzeigen',
  learnMore: 'Mehr erfahren',
  logOut: 'Abmelden',
  chooseLanguage: 'Sprache Wählen',
  chooseYourPreferredLanguage: 'Wählen Sie Ihre bevorzugte Sprache',
  searchLanguages: 'Sprachen suchen...',
  autoDetect: 'Automatische Erkennung',
  noLanguagesFound: 'Keine Sprachen gefunden',
  askAnything: 'Fragen Sie alles',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Persönlich',
  freePlan: 'Kostenloser Plan',
  current: 'Aktuell',
  close: 'Schließen',
  archive: 'Archivieren',
  delete: 'Löschen',
  confirmDelete: 'Sind Sie sicher, dass Sie diesen Chat löschen möchten?',
  confirmArchive: 'Sind Sie sicher, dass Sie diesen Chat archivieren möchten?',
  deleteCannotUndo: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  archiveCanFind: 'Sie können ihn nach der Archivierung in der Archivliste finden.',

  // 归档标签页
  chats: 'Chats',
  archived: 'Archiviert',
  restore: 'Wiederherstellen',
  noArchivedChats: 'Keine archivierten Chats',
  backToChats: 'Zurück zu Chats',

  // 资源面板
  resources: 'Ressourcen',
  addResource: 'Ressource hinzufügen',
  deleteResource: 'Ressource löschen',
  noMatchingResourcesFound: 'Keine passenden Ressourcen gefunden',
  noResourcesAvailable: 'Keine Ressourcen verfügbar',
  hideResources: 'Ressourcen ausblenden',
  showResources: 'Ressourcen anzeigen',

  // 聊天输入框
  typeMessage: 'Nachricht eingeben...',
  thinkingOptions: 'Denkoptionen',
  deleteFile: 'Datei löschen',
  clearSelection: 'Auswahl löschen',
  addAttachment: 'Anhang hinzufügen',
  sendMessage: 'Nachricht senden',

  // 思考模式选项
  deepInsight: 'Tiefe Einsicht · Oberflächenanalyse',
  deepInsightDesc: 'Schnelles Verständnis der Kernpunkte',
  deepExploration: 'Tiefe Erkundung · Umfassende Analyse',
  deepExplorationDesc: 'Mehrdimensionale eingehende Forschung',
  deepDeconstruction: 'Tiefe Dekonstruktion · Systematische Argumentation',
  deepDeconstructionDesc: 'Schichtweise progressive Analyse',

  // 写作模式选项
  contractReview: 'Vertragsüberprüfung · Risikoidentifikation',
  contractReviewDesc: 'Klauselanalyse und Compliance-Prüfung',
  textPolish: 'Textverfeinerung · Professioneller Ausdruck',
  textPolishDesc: 'Sprachoptimierung und Strukturanpassung',
  legalDocuments: 'Rechtsdokumente · Standardentwurf',
  legalDocumentsDesc: 'Professionelle Rechtsdokumentenerstellung',

  // 认证和隐私翻译
  login: 'Anmelden',
  register: 'Registrieren',
  welcomeBack: 'Willkommen bei LawHelper',
  loginSubtitle: 'Ihr KI-Rechtsforschungsassistent',
  continueWithGoogle: 'Mit Google fortfahren',
  continueWithMicrosoft: 'Mit Microsoft fortfahren',
  continueWithWeChat: 'Mit WeChat fortfahren',
  orContinueWith: 'oder fortfahren mit',
  emailTab: 'E-Mail',
  phoneTab: 'Telefon',
  emailPlaceholder: 'E-Mail eingeben',
  phonePlaceholder: 'Telefonnummer eingeben',
  codePlaceholder: '6-stelligen Code eingeben',
  sending: 'Wird gesendet...',
  verifying: 'Wird überprüft...',
  verify: 'Überprüfen',
  sendMagicLink: 'Magic Link senden',
  getVerificationCode: 'Code erhalten',
  resendCode: 'Code erneut senden',
  resendIn: 'Erneut senden in',
  magicLinkSent: 'Magic Link an Ihre E-Mail gesendet',
  magicLinkHint: 'Wir senden einen sicheren Link an Ihre E-Mail',
  otpSent: 'Bestätigungscode gesendet',
  agreeToTerms: 'Durch Fortfahren stimmen Sie unseren zu',
  privacyPolicy: 'Datenschutzrichtlinie',
  termsOfService: 'Nutzungsbedingungen',
  and: 'und',
  privacyTitle: 'Ihre Privatsphäre ist wichtig',
  privacyIntro: 'Wir verwenden Cookies und ähnliche Technologien, um Ihnen das beste Erlebnis zu bieten. Sie können Ihre Präferenzen unten anpassen.',
  essentialCookies: 'Essentielle Cookies',
  essentialDesc: 'Erforderlich für die Webseitenfunktion',
  analyticsCookies: 'Analyse-Cookies',
  analyticsDesc: 'Helfen uns, unseren Service zu verbessern',
  marketingCookies: 'Marketing-Cookies',
  marketingDesc: 'Werden für personalisierte Inhalte verwendet',
  acceptAll: 'Alle akzeptieren',
  essentialOnly: 'Nur essentielle',
  customize: 'Anpassen',
  savePreferences: 'Einstellungen speichern',
  back: 'Zurück',
  readPrivacyPolicy: 'Unsere Datenschutzrichtlinie lesen',
  cookiePolicy: 'Cookie-Richtlinie',
  gdprCompliance: 'DSGVO',
  piplCompliance: 'PIPL (Gesetz zum Schutz personenbezogener Daten)',

  // AI工具面板
  aiReview: 'KI-Prüfung',
  aiDraft: 'KI-Entwurf',
  smartAssistant: 'Vorlage',

  // 知识库搜索
  enableKnowledgeSearch: 'Wissensbasis aktivieren',
  knowledgeSearchDesc: 'KI sucht zuerst in Ihren Dokumenten',
  clickToDisable: 'Deaktivieren',
  clickToEnable: 'Aktivieren',

  // Landing page translations
  tagline: 'KI-gestützte Rechtsintelligenz',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Vereinfacht.',
  jurisdictionsLabel: 'Rechtsgebiete',
  accuracyLabel: 'Genauigkeit',
  fasterLabel: 'Schneller',
  availableLabel: 'Verfügbar',
  platformCapabilities: 'Funktionen',
  testimonialQuote: '"LawHelper hat unsere Arbeit revolutioniert."',
  testimonialAuthor: 'Rechtsexperte',
  testimonialPosition: 'Partner',
  viewPricing: 'Preise',
  footerPricing: 'Preise',
  footerPrivacy: 'Datenschutz',
  footerTerms: 'AGB',
  footerContact: 'Kontakt',
  footerCopyright: '© 2024 LawHelper.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  closeResourcesPanel: 'Ressourcenpanel schließen',
  uploading: '%{fileName} wird hochgeladen...',
  processing: '%{fileName} wird verarbeitet...',
  uploadSuccess: '✓ %{fileName} erfolgreich hochgeladen',
  uploadError: '✗ Upload fehlgeschlagen: %{error}',
  quickAnswer: 'Schnelle Antwort',
  quickAnswerDesc: 'Schnelle Antwort auf einfache Fragen',
  cancelRequest: 'Abbrechen',
  library: 'Bibliothek',
  filterAll: 'Alle',
  filterChat: 'Chats',
  filterReview: 'Prüfung',
  filterDraft: 'Entwurf',
  filterTemplate: 'Vorlage',
  filterForm: 'Formular',
  thinking: 'Denkt nach...',
  thinkingProcess: 'Denkprozess',
  analyzingLegalLogic: 'Rechtliche Logik wird analysiert...',
  lawhelperThinking: 'Lawhelper denkt nach...',
  serviceError: 'Servicefehler',
  uploaded: 'Hochgeladen',
  settingsGeneral: 'Allgemein',
  settingsNotifications: 'Benachrichtigungen',
  settingsAppearance: 'Erscheinungsbild',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Antwortbenachrichtigungen',
  settingsResponseNotificationsDesc: 'Benachrichtigung bei KI-Antwort',
  settingsColorMode: 'Farbmodus',
  settingsLight: 'Hell',
  settingsDark: 'Dunkel',
  settingsSystem: 'System',
  about: 'Über',
  reviewTitle: 'Dokumentenprüfung',
  exitReview: 'Prüfung beenden',
  uploadPrompt: 'PDF hochladen zur Prüfung',
  uploadButton: 'Datei auswählen',
  startChatConfig: 'Geben Sie "Dieses Dokument prüfen" ein',
  reviewPlaceholder: 'Nachricht oder "Dieses Dokument prüfen" eingeben...',
  analyzing: 'Wird geprüft...',
  reviewComplete: 'Prüfung abgeschlossen',
  issuesFound: '%{count} Probleme gefunden',
  draftTitle: 'Rechtsdokument erstellen',
  draftPlaceholder: 'Hier bearbeiten oder KI generieren lassen...',
  analyzingTemplate: 'Vorlage %{name} wird analysiert...',
  templateAnalyzed: '✅ Vorlage %{name} analysiert! Wie möchten Sie sie ändern?',
  templateAnalysisPrompt: 'Schlüsselklauseln der Vorlage analysieren',
  parsingFailed: '⚠️ Datei konnte nicht analysiert werden, aber Sie können Ihre Anforderungen beschreiben.',
  generating: 'Wird generiert...',
  generatedSuccess: '✅ Dokument generiert! Im Editor ansehen und bearbeiten.',
  drafterWelcome: 'Willkommen beim KI-Dokumentenassistenten',
  drafterYouCan: 'Sie können:',
  drafterUploadTemplate: 'Vorlage hochladen zur KI-Analyse',
  drafterDescribeNeeds: 'Dokumentanforderungen beschreiben',
  drafterLetAiHelp: 'KI hilft beim Erstellen von Verträgen, Vereinbarungen usw.',
  drafterExamples: 'Beispiele:',
  drafterExampleRental: '"Erstellen Sie einen Mietvertrag"',
  drafterExampleLabor: '"Arbeitsvertrag nach Vorlage ausfüllen"',
  drafterInputPlaceholder: 'Beschreiben Sie Ihre Dokumentanforderungen...',
  drafterThinking: 'Denkt nach...',
  drafterHistoryTitle: 'Verlauf',
  drafterNoHistory: 'Kein Verlauf',
  drafterNewChat: 'Neuer Chat',
  drafterHistory: 'Verlauf',
  drafterRemoveAttachment: 'Anhang entfernen',
  drafterLineHeight: 'Zeilenhöhe',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Als Word (.docx) exportieren',
  drafterExportPdf: 'Als PDF exportieren',
  drafterSave: 'Dokument speichern',
  drafterDownload: 'Dokument herunterladen',
  drafterUndo: 'Rückgängig',
  drafterRedo: 'Wiederherstellen',
  drafterBold: 'Fett',
  drafterItalic: 'Kursiv',
  drafterStrike: 'Durchgestrichen',
  drafterUnderline: 'Unterstrichen',
  drafterHighlight: 'Hervorheben',
  drafterLink: 'Link einfügen',
  drafterAlignLeft: 'Linksbündig',
  drafterAlignCenter: 'Zentriert',
  drafterAlignRight: 'Rechtsbündig',
  drafterAlignJustify: 'Blocksatz',
  drafterList: 'Liste',
  drafterBulletList: 'Aufzählung',
  drafterOrderedList: 'Nummerierte Liste',
  drafterTaskList: 'Aufgabenliste',
  drafterOpenResource: 'Ressourcenpanel öffnen',
  drafterStopGeneration: 'Generierung stoppen',
  drafterAgentMode: 'Agent-Modus aktiv | Klicken für normalen Chat',
  drafterAgentModeOn: 'Agent-Modus aktiv | Klicken für normalen Chat',
  drafterAgentModeOff: 'Normaler Chat | Klicken für Agent-Modus',
  drafterUploadAttachment: 'Anhang hochladen',
  drafterExit: 'Beenden',
  drafterConfirm: 'Bestätigen',
  drafterOpenLink: 'Link öffnen',
  drafterDeleteLink: 'Link löschen',
  drafterQuote: 'Zitat',
  workflowTitle: 'KI-Workflow',
  workflowRunning: 'Wird ausgeführt...',
  workflowReady: 'Bereit',
  workflowCompleted: 'Abgeschlossen',
  workflowStartFailed: 'Workflow-Start fehlgeschlagen',
  workflowExecutionFailed: 'Workflow-Ausführung fehlgeschlagen',
  workflowInterrupted: 'Workflow unterbrochen',
  workflowProcessing: 'Wird verarbeitet...',
  workflowStepsCompleted: 'Schritte abgeschlossen',
  workflowStepsTotal: 'Workflow abgeschlossen (%{count} Schritte)',
  acceptChanges: 'Änderungen übernehmen',
  rejectChanges: 'Änderungen ablehnen',
  changesAccepted: 'Änderungen übernommen',
  changesRejected: 'Änderungen abgelehnt',
  stopWorkflow: 'Stopp',
  restartWorkflow: 'Neustart',
  startDrafting: 'Entwurf starten',
  interrupt: 'Stopp',
  documentSubject: 'Dokumentbetreff *',
  documentType: 'Dokumenttyp',
  jurisdiction: 'Rechtsgebiet',
  specialRequirements: 'Besondere Anforderungen (optional)',
  clickStartDrafting: 'Klicken Sie "Entwurf starten" für den Workflow',
  docTypeContract: 'Vertrag',
  docTypeAgreement: 'Vereinbarung',
  docTypeNotice: 'Mitteilung',
  docTypeLetter: 'Brief',
  docTypePetition: 'Antrag',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Vollmacht',
  countryChina: 'China',
  countryUSA: 'Vereinigte Staaten',
  countryGermany: 'Deutschland',
  countryJapan: 'Japan',
  countryFrance: 'Frankreich',
  countryUK: 'Vereinigtes Königreich',
  citationVerified: 'Verifiziert',
  citationUnverified: 'Nicht verifiziert',
  imageLoadFailed: 'Bild konnte nicht geladen werden',
  smartDocTitle: 'Intelligenter Dokumentenassistent',
  smartDocChatTitle: 'KI-Dokumentenassistent',
  smartDocDropPrompt: 'PDF-Datei hier ablegen',
  smartDocSelectFile: 'Datei auswählen',
  smartDocOr: 'oder',
  smartDocWelcomeTitle: 'Willkommen beim KI-Dokumentenassistenten',
  smartDocWelcomeYouCan: 'Sie können:',
  smartDocUploadForAI: 'Vorlage hochladen zur KI-Analyse',
  smartDocDescribeDoc: 'Dokumentanforderungen beschreiben',
  smartDocLetAIDraft: 'KI hilft beim Erstellen von Verträgen',
  smartDocExamples: 'Beispiele:',
  smartDocExampleRental: '"Erstellen Sie einen Mietvertrag"',
  smartDocExampleLabor: '"Arbeitsvertrag nach Vorlage ausfüllen"',
  smartDocInputPlaceholder: 'Beschreiben Sie Ihre Dokumentanforderungen...',
  smartDocRemoveAttachment: 'Anhang entfernen',
  smartDocOpenResources: 'Ressourcenpanel öffnen',
  smartDocExit: 'Beenden',
  reviewStartFailed: 'Prüfungsworkflow fehlgeschlagen',
  reviewFailed: 'Prüfung fehlgeschlagen',
  reviewFoundIssues: 'Prüfung abgeschlossen, %{count} Probleme gefunden.',
  cannotReadStream: 'Antwortstream kann nicht gelesen werden',
  parseEventFailed: 'Workflow-Event konnte nicht analysiert werden',
  errorPrefix: 'Fehler',
  unknownError: 'Unbekannter Fehler',
  file: 'Datei',
  loading: 'Wird geladen...',
  localFolders: 'Lokale Ordner',
  selectLocalFolder: 'Lokalen Ordner auswählen',
  reselectFolder: 'Ordner wechseln',
  addToContext: 'Zum Chat hinzufügen',
  saveFile: 'Speichern',
  renameFile: 'Umbenennen',
  fileSaved: 'Datei gespeichert',
  fileRenamed: 'Datei umbenannt in %{name}',
  browserNotSupported: 'Ihr Browser unterstützt keinen lokalen Ordnerzugriff',
  noFolderSelected: 'Wählen Sie einen lokalen Ordner zum Durchsuchen',
  scanningFolder: 'Ordner wird gescannt...',
  selectFileToPreview: 'Datei zur Vorschau auswählen',
  aiAnalyze: 'KI-Analyse',
};
